import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { CallerService } from '../services/caller.service';
import { OnlineStatusService } from '../services/online-status.service';
import { catchError } from 'rxjs/operators';
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class MessagesResolver implements Resolve<any> {
  constructor(
    private callerService: CallerService,
    private onlineStatusService: OnlineStatusService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    return this.callerService.getAllChats()
        .pipe(
          catchError((error) => {
            console.log('messages resolve err?', error);

            // A resolver observable that completes without emitting (e.g. EMPTY) makes the
            // Router silently cancel navigation - the page just never changes, no error shown.
            // Emitting null instead lets the route activate so the failure is visible on the page.
            if (!this.onlineStatusService.isOnline) {
              this.callerService.showNotification("You're offline - messages won't load until you're back online.")
            } else {
              Sentry.captureException(error?.error ?? error);
            }

            return of(null)
          })
        )
    // return of(true);
  }
}
